import React from 'react'
import './Event_Details.css'
import Event_Details_Banner from './event_details_banner/Event_Details_Banner'
import Event_Details_Content from './event_details_content/Event_Details_Content'

const Event_Details = () => {
  return (
    <section className='Event_Details'>
        <Event_Details_Banner/>
        <Event_Details_Content/>
    </section>
  )
}

export default Event_Details
